<template>
  <div v-if="agrupacionesOriginales.length > 0 || props.agrupaciones.length > 0" class="agrupaciones-container">
    <div class="titulo-container-wrapper">
      <div
        class="titulo-container mb-20 mb-m-15"
        :class="{ 'titulo-with-arrows': hasFiltrosAplicados && shouldShowArrows }">
        <span v-if="checkDomain(DOMAINS.roigarena)" class="h4 h5-m semibold m-0 text-primary translate">
          {{ $t('home.seleccionaEventoCompletaExperiencia') }}
        </span>
        <span v-else-if="checkDomain(DOMAINS.transviago)" class="h4 h5-m semibold m-0 text-primary translate">
          {{ $t('home.titleAgrupacionesTransviago') }}
        </span>
        <span v-else-if="checkDomain(DOMAINS.madcup)" class="h4 h5-m semibold m-0 text-primary translate">
          {{ $t('home.titleAgrupacionesMadCup') }}
        </span>
        <span v-else-if="checkDomain(DOMAINS.welcomesailing)" class="h4 h5-m semibold m-0 text-primary translate">
          {{ $t('home.titleAgrupacionesWelcomeSailing') }}
        </span>
        <span v-else-if="checkDomain(DOMAINS.vibess)" class="h4 h5-m semibold m-0 text-primary translate">
          {{ $t('home.titleAgrupacionesVibess') }}
        </span>
        <span v-else class="h4 h5-m semibold m-0 text-primary translate">
          {{ $t('home.exploraNuestrosDestinos') }}
        </span>
        <div
          v-if="hasFiltrosAplicados && shouldShowArrows"
          class="navegacion-arrows navegacion-arrows-titulo d-none d-lg-flex">
          <MyGocuButton
            secondary
            :prefix-icon="arrowLeftIcon"
            additional-class="flex-shrink-0"
            @click="carouselRef.prev()" />
          <MyGocuButton
            secondary
            :prefix-icon="arrowRightIcon"
            additional-class="flex-shrink-0"
            @click="carouselRef.next()" />
        </div>
      </div>
      <div class="filtros-ordenar-wrapper mb-4">
        <div class="row g-2 align-items-center flex-wrap justify-content-between">
          <div class="col-12 col-lg-auto min-w-0 filtros-col d-lg-flex flex-lg-wrap align-items-lg-center gap-2">
            <FiltrosDropdown
              :titulo="$t('general.filtrar')"
              :filtros="
                generateFiltrosAgrupaciones(agrupacionesOriginales.length ? agrupacionesOriginales : props.agrupaciones)
              "
              @filtros-aplicados="applyFiltros($event)" />
          </div>
          <div v-if="shouldShowArrows" class="col-auto order-2 order-lg-0 mt-0">
            <div v-if="!hasFiltrosAplicados" class="navegacion-arrows d-none d-lg-flex justify-content-center">
              <MyGocuButton
                secondary
                :prefix-icon="arrowLeftIcon"
                additional-class="flex-shrink-0"
                @click="carouselRef.prev()" />
              <MyGocuButton
                secondary
                :prefix-icon="arrowRightIcon"
                additional-class="flex-shrink-0"
                @click="carouselRef.next()" />
            </div>
            <div class="navegacion-arrows navegacion-arrows-mobile d-flex d-lg-none">
              <MyGocuButton
                secondary
                :prefix-icon="arrowLeftIcon"
                additional-class="flex-shrink-0"
                @click="carouselRef.prev()" />
              <MyGocuButton
                secondary
                :prefix-icon="arrowRightIcon"
                additional-class="flex-shrink-0"
                @click="carouselRef.next()" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="agrupacionesVisible.length > 0" class="carousel-wrapper">
      <Carousel
        ref="carouselRef"
        :breakpoints="breakpoints"
        snap-align="start"
        :transition="500"
        :touch-drag="shouldShowArrows"
        :mouse-drag="shouldShowArrows">
        <Slide v-for="agrupacion in agrupacionesVisible" :key="agrupacion.id">
          <div class="agrupacion-slide" :style="{ '--bg-img': `url(${agrupacion.imagen})` }">
            <!-- <div class="experiencias-badge small semibold">
              {{ agrupacion.experiencias.length }} {{ $t('builder.title.experiences') }}
            </div> -->
            <div
              class="agrupacion-content pointer"
              @mousedown="startDrag"
              @mousemove="onDrag"
              @mouseup="event => onMouseUp(event, agrupacion.uri)"
              @click="event => onCardClick(event, agrupacion.uri)">
              <div class="agrupacion-nombre h4 h5-m semibold mb-15">{{ agrupacion.nombre }}</div>
              <div v-if="agrupacion.fechaInicio && agrupacion.fechaFin" class="agrupacion-date">
                <CustomIcon :icon="calendarIcon" width="16px" class="text-white" />
                <span class="p medium">{{
                  normalizeFromToDates(agrupacion.fechaInicio, agrupacion.fechaFin)
                }}</span>
              </div>
              <div v-if="agrupacion.ubicacion" class="agrupacion-location">
                <CustomIcon :icon="locationIcon" width="16px" class="text-white" />
                <span class="p medium">{{ agrupacion.ubicacion }}</span>
              </div>
            </div>
          </div>
        </Slide>
      </Carousel>
    </div>
    <SinResultados v-else-if="hasFiltrosAplicados" class="mt-30" />
  </div>
</template>

<script setup>
  import { computed, ref, onBeforeMount } from 'vue';
  import { useRouter } from 'vue-router';
  import { Carousel, Slide } from 'vue3-carousel';
  import 'vue3-carousel/dist/carousel.css';
  import CustomIcon from '@/components/CustomIcon.vue';
  import { normalizeFromToDates } from '@/helpers/dateUtiles';
  import { useCarouselDragPrevention } from '@/helpers/carouselUtils';
  import { AgrupacionDetalle } from '@/router/RouterNames';
  import { checkDomain, DOMAINS } from '@/helpers/domainUtils';
  import FiltrosDropdown from '@/modules/viajesGrupos/components/FiltrosDropdown.vue';
  import MyGocuButton from '@/components/common/buttons/MyGocuButton.vue';
  import { generateFiltrosAgrupaciones, filterAgrupaciones } from '@/helpers/filtrosUtils';
  import SinResultados from '@/components/misc/SinResultados.vue';
  import arrowLeftIcon from '@/assets/icons/arrow-left.svg';
  import arrowRightIcon from '@/assets/icons/arrow-right.svg';
  import calendarIcon from '@/assets/icons/calendar.svg';
  import locationIcon from '@/assets/icons/builder/location.svg';

  const props = defineProps({
    agrupaciones: {
      type: Array,
      required: true,
    },
  });

  const router = useRouter();
  const carouselRef = ref(null);
  const agrupacionesOriginales = ref([]);
  const agrupacionesFiltradas = ref([]);
  const hasFiltrosAplicados = ref(false);

  const { startDrag, onDrag, handleMouseUp, handleCardClick } = useCarouselDragPrevention();

  function sortByFechaInicio(agrupaciones) {
    return [...agrupaciones].sort((a, b) => {
      if (!a.fechaInicio) return 1;
      if (!b.fechaInicio) return -1;
      return new Date(a.fechaInicio) - new Date(b.fechaInicio);
    });
  }

  function onMouseUp(event, uri) {
    handleMouseUp(event, () => goToAgrupacion(uri));
  }

  function onCardClick(event, uri) {
    handleCardClick(event, () => goToAgrupacion(uri));
  }

  const breakpoints = {
    0: {
      itemsToShow: 1.3,
    },
    768: {
      itemsToShow: 3.3,
    },
    1080: {
      itemsToShow: 4.3,
    },
    1500: {
      itemsToShow: 5.3,
    },
    1750: {
      itemsToShow: 5.8,
    },
    1920: {
      itemsToShow: 6.3,
    },
  };

  const shouldShowArrows = computed(() => {
    if (agrupacionesVisible.value?.length === 0) return false;

    const activeBreakpoint = Object.keys(breakpoints)
      .map(Number)
      .reduce((max, breakpoint) => (window.innerWidth >= breakpoint && breakpoint > max ? breakpoint : max), 0);

    return agrupacionesVisible.value?.length > breakpoints[activeBreakpoint].itemsToShow;
  });

  const agrupacionesVisible = computed(() => {
    let agrupaciones;

    if (hasFiltrosAplicados.value) {
      agrupaciones = agrupacionesFiltradas.value;
    } else {
      agrupaciones = agrupacionesOriginales.value.length ? agrupacionesOriginales.value : props.agrupaciones;
    }

    return sortByFechaInicio(agrupaciones);
  });

  function applyFiltros(filtrosAplicados) {
    hasFiltrosAplicados.value = filtrosAplicados && filtrosAplicados.length > 0;
    const agrupacionesToFilter = agrupacionesOriginales.value.length
      ? agrupacionesOriginales.value
      : props.agrupaciones;
    agrupacionesFiltradas.value = filterAgrupaciones(agrupacionesToFilter, filtrosAplicados);
  }

  function goToAgrupacion(uri) {
    router.push({
      name: AgrupacionDetalle,
      params: { uri: uri },
    });
  }

  onBeforeMount(() => {
    if (props.agrupaciones && props.agrupaciones.length > 0) {
      agrupacionesOriginales.value = [...props.agrupaciones];
      agrupacionesFiltradas.value = [...props.agrupaciones];
    }
  });
</script>

<style scoped lang="scss">
  .agrupaciones-container {
    width: 100%;
    justify-content: center;
    position: relative;
    z-index: 1;
    overflow: hidden;
  }

  .titulo-container-wrapper {
    padding: 0px 40px;
    margin-top: 25px;
    @media (max-width: 768px) {
      margin-top: 20px;
      padding: 0px 15px;
    }
  }

  .titulo-container {
    width: 100%;
  }

  .filtros-ordenar-wrapper {
    @media (max-width: 768px) {
      .filtros-col {
        display: contents;
      }
      :deep(.d-lg-none:not(.filtros-aplicados-mobile)) {
        order: 1;
      }
      :deep(.filtros-aplicados-mobile) {
        order: 3;
      }
    }
  }

  .titulo-container.titulo-with-arrows {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .navegacion-arrows {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: auto;
  }

  .carousel-wrapper {
    width: 100%;
    position: relative;
    z-index: 2;
  }

  .agrupacion-slide {
    width: 100%;
    height: 410px;
    position: relative;
    overflow: hidden;
    color: white;
    display: flex;
    flex-direction: column;
    border-radius: var(--bs-border-radius-xl);
    padding: 20px;
    flex-shrink: 0;

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-image: var(--bg-img);
      background-size: cover;
      background-position: center;
      z-index: 0;
      transition: transform 0.3s ease;
    }

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(var(--bs-primary-rgb), 0.3);
      z-index: 1;
      border-radius: var(--bs-border-radius-xl);
    }

    &:hover::after {
      transform: scale(1.2);
    }
  }

  .experiencias-badge {
    position: absolute;
    top: 20px;
    left: 20px;
    color: var(--bs-primary);
    padding: 8px 18px;
    border-radius: var(--bs-border-radius-xxl);
    z-index: 10;
    background-color: rgba(var(--bs-white-rgb), 0.8);
    backdrop-filter: blur(6px);
    border: 1px solid linear-gradient(86deg, rgba(var(--bs-white-rgb), 0.72) 0%, rgba(var(--bs-white-rgb), 0.9) 100%);

    @media (max-width: 768px) {
      top: 15px;
      left: 15px;
    }
  }

  .agrupacion-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
    width: 100%;
    height: 100%;
    text-align: center;
    position: relative;
    z-index: 2;
    cursor: pointer;
  }

  .agrupacion-nombre {
    color: #ffffff;
    text-align: center;
    text-shadow: 0px 0px 20px rgba(var(--bs-primary-rgb), 0.6);
  }

  .agrupacion-date {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    gap: 10px;
    margin-bottom: 7px;

    :deep(.custom-icon) {
      flex-shrink: 0;
      width: 16px;
      min-width: 16px;
    }
  }

  .agrupacion-location {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    gap: 10px;

    :deep(.custom-icon) {
      flex-shrink: 0;
      width: 16px;
      min-width: 16px;
    }
  }

  :deep(.carousel__track) {
    margin-bottom: 20px;
  }

  :deep(.carousel__slide) {
    padding-right: 20px;

    &:first-child {
      margin-left: 40px;

      @media (max-width: 768px) {
        margin-left: 15px;
      }
    }
  }
</style>
